import { ErrorBoundary } from 'shared-ui';

import { fetchMonitoringObecnosci, fetchStrefy } from 'api/strefy/strefy';
import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { Zones } from './Zones';

export const ZonesContainer = () => {
  const { perms } = usePermissions();

  const { data: zonesResponse, isLoading } = useQuery([QueryKeyEnum.STREFY], fetchStrefy);
  const { data: monitoring, isLoading: isLoadingMonitoring } = useQuery(
    [QueryKeyEnum.MONITORING_OBECNOSCI],
    fetchMonitoringObecnosci,
  );

  const isMonitoringActive = !!monitoring?.aktywny;
  const isModifyDisabled = !perms?.[Functionality.DEFINICJE]?.edit || isLoadingMonitoring || isMonitoringActive;

  return (
    <ErrorBoundary>
      <Zones
        zones={zonesResponse?.data || []}
        isLoading={isLoading}
        isModifyDisabled={isModifyDisabled}
        isMonitoringActive={isMonitoringActive}
      />
    </ErrorBoundary>
  );
};
